import React from "react";
import PageShell from "@/components/PageShell";
import { Download, ArrowUpRight } from "lucide-react";

const FEATURES = [
    {
        outlet: "Hypebeast",
        date: "MAR 2026",
        title: "UKnitwear FW26: Concrete Hours",
        excerpt: "“…the most considered heavyweight knitwear collection out of London this season.”",
    },
    {
        outlet: "Highsnobiety",
        date: "FEB 2026",
        title: "Inside the Foundry: How UKnitwear Builds a Drop",
        excerpt: "“A studio tour with the team behind streetwear's most disciplined production schedule.”",
    },
    {
        outlet: "Dazed",
        date: "JAN 2026",
        title: "The Quiet Cult of UKnitwear",
        excerpt: "“They don't shout. The clothes do that for them.”",
    },
    {
        outlet: "i-D",
        date: "DEC 2025",
        title: "10 Brands Defining Post-Streetwear",
        excerpt: "“UKnitwear sits at the intersection of utility, knit and brutalist design.”",
    },
    {
        outlet: "GQ Style",
        date: "OCT 2025",
        title: "The Heavyweight Hoodie, Reconsidered",
        excerpt: "“500gsm. Boxy. Honest. The Concrete Hoodie is the benchmark.”",
    },
    {
        outlet: "Vogue Business",
        date: "AUG 2025",
        title: "Small Brands, Big Impact: 5 To Watch",
        excerpt: "“UKnitwear's slow-run model is a quiet rebuke to fast fashion.”",
    },
];

const Press = () => {
    return (
        <PageShell
            kicker="[Press / Media]"
            title="On The"
            accent="Record."
            intro="Editorials, interviews, and features. For new requests, contact press@uknitwear.com — we typically reply within 48 hours."
            testid="press-page"
        >
            <section className="border-b-4 border-ink">
                <div
                    className="grid grid-cols-1 md:grid-cols-2 divide-y-2 md:divide-y-0 divide-ink"
                    data-testid="press-grid"
                >
                    {FEATURES.map((f, i) => (
                        <article
                            key={f.title}
                            className={`p-6 md:p-10 border-ink ${
                                i % 2 === 0 ? "md:border-r-2" : ""
                            } ${i >= 2 ? "md:border-t-2" : ""}`}
                            data-testid={`press-item-${i}`}
                        >
                            <div className="flex items-center justify-between gap-2 mb-4">
                                <span className="font-heading text-3xl uppercase">{f.outlet}</span>
                                <span className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
                                    {f.date}
                                </span>
                            </div>
                            <h3 className="font-heading text-2xl md:text-3xl uppercase leading-none">
                                {f.title}
                            </h3>
                            <p className="mt-3 text-sm italic text-foreground/80">{f.excerpt}</p>
                            <a
                                href="#"
                                className="inline-flex items-center gap-2 mt-4 font-mono-ui text-[10px] uppercase tracking-[0.25em] hover:text-hazard"
                                data-testid={`press-link-${i}`}
                            >
                                Read Feature <ArrowUpRight className="w-3 h-3" />
                            </a>
                        </article>
                    ))}
                </div>
            </section>

            <section className="grid grid-cols-1 md:grid-cols-2 border-b-4 border-ink">
                <div className="p-6 md:p-12 md:border-r-2 border-ink">
                    <span className="font-mono-ui text-xs uppercase tracking-[0.25em] text-muted-foreground">
                        // Assets
                    </span>
                    <h2 className="font-heading text-4xl md:text-5xl uppercase leading-none mt-1">
                        Press Kit
                    </h2>
                    <p className="mt-4 text-sm md:text-base">
                        Hi-res lookbook imagery, brand logos, founder bios, and the
                        full FW26 line sheet.
                    </p>
                    <a
                        href="#"
                        className="inline-flex items-center gap-2 mt-6 bg-ink text-black border-2 border-ink px-6 py-3 font-mono-ui text-xs uppercase tracking-[0.25em] hover:bg-hazard hover:border-hazard"
                        data-testid="press-kit-download"
                    >
                        <Download className="w-4 h-4" /> Download Kit (220 MB)
                    </a>
                </div>
                <div className="p-6 md:p-12 bg-ink text-black">
                    <span className="font-mono-ui text-xs uppercase tracking-[0.25em] text-black/40">
                        // Contact
                    </span>
                    <h2 className="font-heading text-4xl md:text-5xl uppercase leading-none mt-1">
                        Press Desk
                    </h2>
                    <p className="mt-4 text-sm md:text-base text-black/80">
                        For interviews, samples, and feature requests.
                    </p>
                    <p className="mt-4 font-mono-ui text-sm">
                        press@uknitwear.com
                        <br />
                        +44 (0)20 0000 0000
                    </p>
                </div>
            </section>
        </PageShell>
    );
};

export default Press;
